var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_11576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7C7.183 7 8.75 5.433 8.75 3.5C8.75 1.567 7.183 0 5.25 0C3.317 0 1.75 1.567 1.75 3.5C1.75 5.433 3.317 7 5.25 7Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60842 8.1665H2.89158C2.12497 8.16743 1.39002 8.47238 0.847948 9.01445C0.305872 9.55653 0.000926233 10.2915 0 11.0581L0 13.9998H10.5V11.0581C10.4991 10.2915 10.1941 9.55653 9.65205 9.01445C9.10998 8.47238 8.37503 8.16743 7.60842 8.1665Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.8335V4.0835H11.0834V5.8335H9.33337V7.00016H11.0834V8.75016H12.25V7.00016H14V5.8335H12.25Z",
    fill: "#6F7CED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_11576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.90502f6d.svg";
export { ForwardRef as ReactComponent };